
import GridMainSection from "../PageElements/DoctorsGridPageElements/GridMainSection";
import ConsultSection from "../PageElements/HomePageElements/ConsultSection";

export default function DoctorsGridPage() {
    // const [centerList, setCenterList] = useState([]);
    return (
        <>
            
            <GridMainSection/>
            {/* <ServiceSection/> */}
            {/* <ConsultSection /> */}
        </>
    )
}